/* istanbul ignore file */
export { media, Media } from './media';
export * from './types';
export * from './constants';
export {
  Vendor,
  MediaEventType,
  MediaStorageKeys,
  MediaAccessStatus,
  MediaAccessError,
  FacingMode,
  type VideoQuality,
  VideoQualityProfiles,
  VideoQualityProfilesWide,
} from './media.constants';
export type {
  SpeakerId,
  CameraId,
  MicrophoneId,
  MediaSettings,
  AspectRatio,
  VirtualBackgroundFilter,
  MediaVideoConstraints,
  MediaAudioConstraints,
  MediaConstraints,
  SelectedDevicesChangeEvent,
  Resolution,
} from './media.types';
